<template>
  <section>
    <div class="content-wrapper content-wrapper-banner">
      <div class="content-heading">
        Account details
        <small data-localize="dashboard.WELCOME"></small>
      </div>
       <div class="panel b text-white banner-width">
        <div class="panel-body bg-cover clearfix">
          <div class="media mt0">
            <div class="media-left">
              <a href="#">
                <img :src="getAccountImgUrl(activeAccount.accountType)" alt="Image" class="media-object img-thumbnail img-circle thumb45">
              </a>
            </div>
            <div class="media-body media-middle">
              <div class="clearfix">
                <div class="pull-left">
                  <p class="information-title">{{accountType}} account</p>
                  <h4 class="media-heading m0">{{activeAccount.accountName}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper content-wrapper-container">
      <div class="row">
        <spinner v-if="isLoading"></spinner>
        <div class="col-lg-12">
          <div id="panelChart9" class="panel panel-default">
            <div class="panel-title">
              Account information
            </div>
             <div class="row top-margin">
              <div class="col-md-6">
                <div class="form-group form-flex">
                  <label class="field-label">Account name</label>
                  <label class="value-label" id="account-name">{{activeAccount.accountName}}</label>
                </div>
              </div>
               <div class="col-md-6">
                <div class="form-group form-flex">
                  <label class="field-label">Account ID</label>
                  <label class="value-label" id="account-id">{{accountId}}</label>
                </div>
              </div>
              <div id="advisor-info-container" v-if="isAdvisor">
                <div class="col-md-6">
                  <div class="form-group form-flex">
                    <label class="field-label">Organization name</label>
                    <label class="value-label" id="account-id">{{organizationName}}</label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group form-flex">
                    <label class="field-label">Optional organization name</label>
                    <label class="value-label" id="account-id">{{alternateCompanyName}}</label>
                  </div>
                </div>
                <div class="col-md-12 empty-container">
                  <div class="col-md-6" style="float: left">
                  <div class="form-group form-flex">
                    <label class="field-label">CRD number</label>
                    <label class="value-label" id="account-id">{{crdNumber}}</label>
                  </div>
                </div>
                <div class="col-md-6"></div>
                </div>


               </div>
              </div>
              <div v-if="isInstitution || isTrust" class="row top-margin">
                <div class="col-md-6">
                   <div class="form-group form-flex">
                    <label class="field-label">Phone Number</label>
                    <label class="value-label" id="account-id">{{formatPhoneNumber(phoneNumber)}}</label>
                  </div>
                </div>
              </div>
              <div id="users-container" v-if="!isAdvisor">
                <div class="line-separator"></div>
                <div class="panel-title">
                  Authorized representatives
                </div>
              <div :class="{'table-fixed-header--md cols-9': representatives.length > 6}" class="table-responsive bottom-margin">
                <table class="table table-striped">
                <thead>
                  <tr>
                    <th class="text-left">Name</th>
                    <th class="text-center">Type</th>
                    <th class="text-center">Primary investor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(representative, index) in representatives" :key="index">
                    <td class="text-left">{{ representative.firstName }} {{ representative.lastName }}</td>
                    <td class="text-center">{{ getUserTypeLabel(representative.userType) }}</td>
                    <td class="text-center">
                      <div v-if="representative.userType !== 'ADVISOR' && representative.id === accountPrimaryInvestorId" :class="{ 'radio-item': true, 'radio-item-unselected': representative.id !== accountPrimaryInvestorId } ">
                        <input type="radio"  :value="true" readonly/>
                        <label />
                      </div>
                    </td>
                  </tr>
                </tbody>
                </table>
              </div>
            </div>
            <div id="users-container" v-if="!isInstitution">
                <div class="line-separator"></div>
                <div class="panel-title">
                  Beneficiary Information
                </div>
              <div v-if="beneficiaries.length > 0" :class="{'table-fixed-header--md cols-9': beneficiaries.length > 6}" class="table-responsive bottom-margin">
                <table class="table table-striped">
                <thead>
                  <tr>
                    <th class="text-left">Name</th>
                    <th class="text-center">Percentage</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(beneficiary, index) in beneficiaries" :key="index">
                    <td class="text-left">{{ beneficiary.beneficiaryName }}</td>
                    <td class="text-center">{{ beneficiary.percentage }}%</td>
                  </tr>
                </tbody>
                </table>
              </div>
              <div v-else>
                <div class="alert alert-info alert-dismissible" role="alert">
                  <p>No beneficiaries found.</p>
                  <p>Go to <a href="https://calvertimpact.org/beneficiary" target="_blank" class="alert-link">calvertimpact.org/beneficiary</a> and follow the instructions to request beneficiaries to be added.</p>
                </div>
              </div>
            </div>

          <div v-if="isInstitution || isTrust">
            <div class="line-separator"></div>
             <div class="panel-title">
              {{accountType}} Address
            </div>
            <div class="row top-margin">
              <div class="col-md-6">
                <div class="form-group form-flex">
                  <label class="field-label">Street Address</label>
                  <label class="value-label" id="residentail-addressa">{{mainAddress.streetAddress1}}</label>
                </div>
              </div>
              <div class="col-md-6">

              </div>
            </div>
            <div class="row top-margin">
              <div class="col-md-4">
                <div class="form-group form-flex">
                  <label class="field-label">Zip code</label>
                  <label class="value-label" id="residentail-zipCode">{{mainAddress.zipCode}}</label>
                </div>
              </div>
              <div class="col-md-4">
                 <div class="form-group form-flex">
                  <label class="field-label">City</label>
                  <label class="value-label" id="residentail-Address">{{mainAddress.city}}</label>
                </div>
              </div>
              <div class="col-md-4">
                 <div class="form-group form-flex">
                  <label class="field-label">State</label>
                  <label class="value-label" id="residentail-State">{{getStateFullName(mainAddress.state)}}</label>
                </div>
              </div>
            </div>
            <div class="line-separator"></div>
             <div class="panel-title">
              Mailing Address
            </div>
            <div class="row top-margin">
              <div class="col-md-6">
                <div class="form-group form-flex">
                  <label class="field-label">Street Address</label>
                  <label class="value-label" id="mailing-address">{{mailingAddress.streetAddress1}}</label>
                </div>
              </div>
              <div class="col-md-6">

              </div>
            </div>
            <div class="row top-margin">
              <div class="col-md-4">
                <div class="form-group form-flex">
                  <label class="field-label">Zip code</label>
                  <label class="value-label" id="mailing-zipCode">{{mailingAddress.zipCode}}</label>
                </div>
              </div>
              <div class="col-md-4">
                 <div class="form-group form-flex">
                  <label class="field-label">City</label>
                  <label class="value-label" id="mailing-City">{{mailingAddress.city}}</label>
                </div>
              </div>
              <div class="col-md-4">
                 <div class="form-group form-flex">
                  <label class="field-label">State</label>
                  <label class="value-label" id="mailing-State">{{getStateFullName(mailingAddress.state)}}</label>
                </div>
              </div>
            </div>
             </div>
            <div class="line-separator"></div>
            <div class="account-notice">
              <div class="alert alert-info alert-dismissible mt-lg" role="alert">
              <p class="information-message">Please contact us at info@calvertimpact.org if you have any account questions or changes.</p>
            </div>
              <div class="alert alert-info alert-dismissible mt-lg" role="alert">
                <p class="information-message">Calvert Impact staff will never have access to or ask you for your password. You can reset your password anytime at <a href="https://invest.calvertimpactcapital.org/#/reset-password">https://invest.calvertimpactcapital.org/#/reset-password</a>.</p>
              </div>
          </div>
          </div>
          </div>
        </div>
      </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { SET_ERRORS_MODAL_INFO, SHOW_ERRORS_MODAL } from '@/store/mutation-types';
import { capitalize, getUserTypeLabel, getAccounTypeProperties } from '@/util';
import spinner from '@/components/widgets/Spinner';
import { AccountTypes } from '@/data/static/accountTypes';


const mix = {
  methods: {
    getUserTypeLabel,
  },
};
export default {
  name: 'InvestorAccountDetails',
  mixins: [mix],
  data() {
    return {
      representatives: [],
      isLoading: true,
      accountPrimaryInvestorId: 0,
      accountId: '',
      mainAddress: {},
      mailingAddress: {},
      phoneNumber: '',
      organizationName: '',
      alternateCompanyName: '',
      crdNumber: '',
      beneficiaries: [],
    };
  },
  beforeMount() {
    this.getAccountDetails();
    this.getAccountBeneficiariesDetails();
  },
  components: {
    spinner,
  },
  methods: {
    ...mapMutations('errors', {
      showErrorsModal: SHOW_ERRORS_MODAL,
      setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
    }),
    ...mapActions('account', [
      'getAccountUsers',
      'getAccount',
      'getAccountOrganizations',
      'getAccountBeneficiaries',
    ]),
    async getAccountDetails() {
      try {
        const [accountUsersRepresentatives, account, accountOrganizations] = await Promise.all([
          this.getAccountUsers(this.activeAccountId),
          this.getAccount(this.activeAccountId),
          this.getAccountOrganizations(this.activeAccountId),
        ]);

        this.accountPrimaryInvestorId = account.primaryInvestorId;
        this.representatives = this.sortRepresentatives(accountUsersRepresentatives);
        this.accountId = account.accountId;
        if ((this.isInstitution || this.isTrust) && accountOrganizations.length) {
          const accountOrganization = accountOrganizations[0];
          this.mainAddress = accountOrganization.mainAddress;
          this.mailingAddress = accountOrganization.mailingAddress;
          this.phoneNumber = accountOrganization.phoneNumber;
        }
        if (this.isAdvisor) {
          this.organizationName = account.organizationName;
          this.alternateCompanyName = account.alternateCompanyName;
          this.crdNumber = account.CRDnumber;
        }
        this.isLoading = false;
      } catch (error) {
        this.setErrorsModalInfo(['We could not retrieve account details']);
        this.showErrorsModal();
        this.isLoading = false;
      }
    },
    async getAccountBeneficiariesDetails() {
      const beneficiaries = await this.getAccountBeneficiaries(this.activeAccountId);
      this.beneficiaries = beneficiaries;
    },
    getStateFullName(abbreviation) {
      let foundState = this
        .geoLocation.states.find(state => state.abbreviation === abbreviation);
      if (!foundState) {
        foundState = this
        .geoLocation.canadaStates.find(state => state.abbreviation === abbreviation);
      }
      return abbreviation ? foundState.name : '';
    },
    formatPhoneNumber(number) {
      return number.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    },
    getAccountImgUrl(type) {
      const accountTypeIcon = `${getAccounTypeProperties(type).icon}`;
      return require(`@/assets/img/user/${accountTypeIcon}.svg`); // eslint-disable-line
    },
    sortRepresentatives(data = []) {
      data.forEach((item, i) => {
        if (item.id === this.accountPrimaryInvestorId) {
          data.splice(i, 1);
          data.unshift(item);
        }
      });
      return data;
    },
  },
  computed: {
    ...mapState('app', [
      'activeAccountId',
      'activeAccount',
      'geoLocation',
    ]),
    isInstitution() {
      return this.activeAccount.accountType === AccountTypes.INSTITUTION.name;
    },
    isTrust() {
      return this.activeAccount.accountType === AccountTypes.TRUST.name;
    },
    isAdvisor() {
      return this.activeAccount.accountType === AccountTypes.ADVISOR.name;
    },
    accountType() {
      return capitalize(this.activeAccount.accountType);
    },
  },
};
</script>

<style scoped>
  .information-title {
   color: #63adba;
   margin-bottom: 5px;
   font-size: 14px;
  }

  .thumb45 {
    width: 40px !important;
    height: 40px !important;
    margin-top: 6px;
    margin-left: 33px;
  }

  .media-heading {
    font-weight: 400;
    font-size: 24px;
  }

  .panel, .panel-body {
    border-radius: 4px;
  }

  .bg-cover {
    background-color: #00798e;
    padding: 10px !important;
    box-sizing: border-box;
  }

  .title-panel {
    box-shadow: 0 -2px 0 0 rgba(0, 0, 0, 0.15);
    border: solid 1px #004f5c;
  }

  .content-wrapper {
    border-top: none;
    word-wrap: break-word;
  }
  .content-wrapper-banner {
    border-top: none;
    padding-bottom: 0px;
  }
  .content-wrapper-container {
    border-top: none;
    padding-top: 0px;
  }

  .form-flex {
    display: flex;
    flex-direction: column;
  }

  .field-label {
    color: #7b7c7e;
    font-size: 14px;
  }

  .value-label {
     font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #373a3c;
  }

  .panel-title {
    font-size: 16px;
    margin-bottom: 20px;
  }

  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }

  th {
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #7a7c7f;
  }

  .information-message {
    font-size: 16px;
  }

  .account-notice {
    margin-top: 15px;
  }
.radio-item label {
    color: #666;
    font-weight: normal;
    padding-left: 25px;
    padding-top: 5px;
    cursor: pointer;
  }
  .radio-item {
    height: 25px;
  }
  .radio-item label:before {
    content: " ";
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0px;
    margin: 0 5px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    background-color: transparent;
  }
  .radio-item-unselected label:before {
    border: 2px solid #d3d3d3;
  }
  .radio-item label:after {
    border-radius: 5px;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 5px;
    left: 5px;
    margin: auto;
    content: "";
    display: block;
    background-color: #127285;
  }
  .radio-item.radio-item-unselected label:after {
    display: none;
  }

  tr {
    font-size: 16px;
    font-weight: normal;
  }

  .table-responsive {
    padding: 0 80px 0 10px;
    margin-bottom: 60px;
  }

  .empty-container {
    padding-left: 0;
  }
</style>



// WEBPACK FOOTER //
// InvestorAccountDetails.vue?772d9678